import { useNavigate } from "react-router-dom";

export function KpiCard({ title, value, icon: Icon, trend, to, iconBg = "bg-primary-light", iconColor = "text-primary", disabled = false, loading = false }) {
  const navigate = useNavigate();

  return (
    <div
      onClick={to && !disabled ? () => navigate(to) : undefined}
      className={`glass-card rounded-xl p-5 transition-all duration-200 animate-fade-in relative
        ${to && !disabled ? "glass-card-hover cursor-pointer" : "cursor-not-allowed"} 
        ${disabled ? "opacity-75 grayscale-[0.3]" : ""}`}
    >
      <div className="flex items-center justify-between">
        <div>
          <div className="flex items-center gap-2">
            <p className="text-sm text-muted-foreground font-medium">{title}</p>
            {disabled && (
              <span className="text-[9px] px-1.5 py-0.5 rounded-full bg-primary/10 text-primary border border-primary/20 font-bold uppercase tracking-wider">
                Locked
              </span>
            )}
          </div>
          {loading ? (
            <div className="skeleton-shimmer h-8 w-20 rounded-md mt-1.5" />
          ) : (
            <p className="text-2xl font-bold mt-1">{value}</p>
          )}
          {trend && <p className="text-xs text-success mt-1 font-medium">{trend}</p>}
        </div>
        <div className={`w-14 h-14 rounded-full ${iconBg} flex items-center justify-center`}>
          <Icon size={26} className={iconColor} />
        </div>
      </div>
    </div>
  );
}
